<h1 mat-dialog-title>{{data.titulo}}</h1>
<div mat-dialog-content>
  <p>{{data.mensagem}}</p>
</div>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button class="md-icon-button btnNok" (click)="onCloseClick()">
    <img class="img-fluid" src="assets/icons/white_close_icon.png"  width="16px"/> Fechar
  </button>
</div>